export default "__VITE_ASSET__Cs_$QxUq__"